import { useEffect } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SavedPaymentMethodContent } from 'src/app/pages/promote/shared/types';
import { treatExperiment } from 'src/app/shared/api/experiments';

import { usePromotePageData } from '../../../pageData';
import { usePromotePageState } from '../../../pageState';

export const useTreatSavedPaymentExperiment = (savedPaymentMethods: SavedPaymentMethodContent[]) => {
	const {
		data: { savedPaymentExperiment },
	} = usePromotePageData();
	const utilityContext = useUtilityContext();
	const [
		{ savedPaymentExperimentVariant },
		{ setUsingSavedPaymentMethod, setPaymentType, setSavedPaymentExperimentVariant },
	] = usePromotePageState();

	useEffect(() => {
		async function run() {
			if (
				savedPaymentMethods.length > 0 &&
				!savedPaymentExperimentVariant &&
				savedPaymentExperiment.experimentName !== '__invalid_experiment__'
			) {
				await treatExperiment(utilityContext, savedPaymentExperiment.experimentName);
				setSavedPaymentExperimentVariant(savedPaymentExperiment.variation);
				if (savedPaymentExperiment.variation !== 'control') {
					setUsingSavedPaymentMethod(true);
					setPaymentType(savedPaymentMethods[0].type);
				}
			}
		}
		void run();
	}, [savedPaymentMethods, savedPaymentExperimentVariant]);
};
